export default "__VITE_ASSET__CWfXWypw__"